'use strict';

var implementation$1 = require('./implementation.js');

var implementation = implementation$1;

var polyfill = function getPolyfill() {
	return Array.prototype.flat || implementation;
};

module.exports = polyfill;
